module.exports = __webpack_public_path__ + "img/vip.c0248130.png";